<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >{{offer.cusip}}</h5> 
              <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>

            </div>
            <div class="modal-body">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                        <th scope="col" class="text-center">ECN</th>
                        <th scope="col" class="text-center">PRICE</th>
                        <th scope="col" class="text-center">QTY/MIN</th>
                        <th scope="col" class="text-center">SETTLEMENT</th>
                        <th scope="col" class="text-center">COST</th>
                        <th scope="col" class="text-center">SOURCE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="offers.length == 0 && !loading">
                        <td><p class="nodata">No data available</p>
                        </td>
                    </tr>
                    <tr v-for="offer in offers" :key="offer.id">
                        <td><span>{{offer.ecn}}</span></td>
                        <td><span>{{offer.askPx | currency }}</span></td>
                        <td><span>{{offer.askQty}} / {{offer.minQty ? offer.minQty : "N/A"}}  </span></td>
                        <td><span>{{offer.settlementDate ? moment(offer.settlementDate).format("MM/DD/YYYY"): ''}}</span></td>
                        <td><span>{{offer.cost | currency}}</span></td>
                        <td><span>{{offer.offerSource}}</span></td>
                       
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerEmails',
        components :{
            
        },
        props: ['offer'],
        data() {
            return {
                loading : false,
                offers : [],      
            }
        },
        methods: {  
            getOffers(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlAutoBidder +
                    "/offering-feed/cusip-offers?cusip="+this.offer.cusip,
                    auth
                )
                .then(result => {
                    this.offers = result.data;
                    this.loading = false;
                })
            }

        },
        mounted(){
          this.getOffers();
        }
    };
    </script>